<app-navbar/>
<div class="superadmin-container">
  <div class="superadmin-header">
    <h2>Visão Superadmin — Tickets Abertos</h2>
    <div class="actions">
      <button class="btn btn-primary" (click)="loadTickets()">Atualizar</button>
    </div>
  </div>

  <div *ngIf="!tickets || tickets.totalElements === 0" class="empty">Nenhum ticket aberto encontrado.</div>

  <div *ngIf="tickets && tickets.content.length">
    <div class="tickets-grid">
      <div class="ticket-card" *ngFor="let t of tickets.content">
        <div class="ticket-top">
          <div class="ticket-id">#{{ t.numeroExibicao || t.id }}</div>
          <div class="ticket-status">{{ t.status | titlecase }}</div>
        </div>
        <h3 class="ticket-title">{{ t.titulo }}</h3>
        <p class="ticket-desc">{{ t.descricao }}</p>
        <div class="ticket-meta">
          <span>Usuário: {{ who(t) }}</span>
          <span>Criado: {{ t.criadoEm | date:'short' }}</span>
          <span *ngIf="t.atualizadoEm">Atualizado: {{ t.atualizadoEm | date:'short' }}</span>
        </div>

        <div class="ticket-actions">
          <select [(ngModel)]="selectedStatus[t.id]">
            <option value="ABERTO">Aberto</option>
            <option value="EM_ANDAMENTO">Em Andamento</option>
            <option value="RESOLVIDO">Resolvido</option>
            <option value="FECHADO">Fechado</option>
            <option value="AGUARDANDO_USUARIO">Aguardando Usuário</option>
            <option value="CANCELADO">Cancelado</option>
          </select>
          <button class="btn btn-primary" (click)="applyStatus(t.id)">Aplicar</button>
        </div>
      </div>
    </div>
  </div>
</div>
